import {
  useCsAttribute,
  useSyncInfo,
} from "@plansoft-configuration-renderer/framework";

export function useTableControlReadonlyOptions() {
  const { isSyncing } = useSyncInfo();
  const attribute = useCsAttribute();
  const disabled = attribute.isReadOnly || isSyncing;
  return {
    muiSelectCheckboxProps: {
      disabled,
    },
    muiSelectAllCheckboxProps: {
      disabled,
    },
  };
}
// sourceMappingURL=useTableControlReadonlyOptions.js.map
